export default (userRoles = [], authorisedRoles = []) => {
  if (!userRoles.length) {
    return false;
  }
  return userRoles.some((role) => authorisedRoles.indexOf(role) > -1);
};
